import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedPayrollEventRetrieveList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined | null)[];
}

interface IUsePayrollEvents {
  search?: string;
  ordering?: string;
  staffId?: string;
  payrollPeriod?: string | null;
  limit?: string;
  enabled?: boolean;
  csvExport?: string;
}

function usePayrollEvents({
  search,
  ordering,
  staffId,
  payrollPeriod,
  limit = '20',
  enabled = true,
  csvExport,
}: IUsePayrollEvents): UseInfiniteQueryResult<AxiosResponse<PaginatedPayrollEventRetrieveList>> {
  const fetchPayrollEvents = ({
    pageParam = { limit, offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedPayrollEventRetrieveList>> => {
    const params = pageParam;

    if (search) {
      params.search = search;
    }

    if (!!staffId) {
      params.staff_id = staffId;
    }

    if (!!payrollPeriod) {
      params.payroll_period = payrollPeriod;
    }

    if (ordering) {
      params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
    }

    return client.get(`payroll-events/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(
    ['payrollEvents', search, ordering, staffId, payrollPeriod, csvExport],
    fetchPayrollEvents,
    {
      getNextPageParam: page => {
        return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
      },
      enabled,
    },
  );
}

export default usePayrollEvents;
